import { useGallery } from '@media-ui/gallery/src/components/Gallery/GalleryHooks';
import { getItemsWithSourcePrefix } from './useShowGallery.utils';
import * as T from './useShowGallery.types';
export const useInfographicGalleries = ({ initialInfographicItems, galleryProps, articleID, }: T.IUseInfographicGalleries) => {
    const infographicGalleries = initialInfographicItems.reduce<T.IGalleryInfographics>((acc, currentItem) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        acc[currentItem.id] = useGallery(`Gallery-infographic${currentItem.id}-${articleID}`, {
            galleryProps: {
                ...galleryProps,
                items: getItemsWithSourcePrefix([currentItem]),
            },
        }).show;
        return acc;
    }, {});
    return { infographicGalleries };
};
